// Add-to-cart confirmation sound. On by default, and switchable off.
//
// No audio context exists until the shopper first touches the page, and the
// tone only ever follows a real add, so nothing here autoplays: the add itself
// is the gesture that lets the context run. The control stays so the sound can
// be turned off, and that choice is remembered.
(() => {
  const button = document.querySelector('[data-tonus-sound]');
  if (!button || !window.AudioContext) return;
  /* Versioned: the previous key was written while the sound was opt-in, so a
     stored "off" from that era would keep the new default from ever applying.
     A new key starts everyone on the current default and still remembers an
     opt-out from here on. */
  const key = 'tonus-sound-enabled-v2';
  let enabled = true;
  let context;
  let lastPlayed = -Infinity;
  try { enabled = localStorage.getItem(key) !== 'false'; } catch { /* Storage is optional. */ }
  const update = () => {
    button.setAttribute('aria-pressed', String(enabled));
    button.querySelector('[data-sound-label]').textContent = enabled ? button.dataset.on : button.dataset.off;
  };
  const resume = () => {
    if (!enabled) return;
    try {
      context ||= new AudioContext();
      if (context.state === 'suspended') void context.resume().catch(() => {});
    } catch { /* Sound must never affect checkout. */ }
  };
  const play = () => {
    if (!enabled || document.hidden || context?.state !== 'running' || performance.now() - lastPlayed < 650) return;
    lastPlayed = performance.now();
    try {
      [660, 880].forEach((frequency, index) => {
        const start = context.currentTime + index * 0.045;
        const tone = context.createOscillator();
        const gain = context.createGain();
        tone.type = 'sine';
        tone.frequency.value = frequency;
        gain.gain.setValueAtTime(0, start);
        gain.gain.linearRampToValueAtTime(0.024, start + 0.009);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.14);
        tone.connect(gain).connect(context.destination);
        tone.start(start);
        tone.stop(start + 0.15);
        tone.onended = () => { tone.disconnect(); gain.disconnect(); };
      });
    } catch { /* Silent fallback. */ }
  };
  button.hidden = false;
  update();
  button.addEventListener('click', () => {
    enabled = !enabled;
    try { localStorage.setItem(key, String(enabled)); } catch { /* Storage is optional. */ }
    update();
    if (enabled) {
      resume();
      if (context) void context.resume().then(play).catch(() => {});
    } else if (context) { void context.suspend().catch(() => {}); }
  });
  document.addEventListener('pointerdown', resume, { passive: true });
  document.addEventListener('keydown', resume);
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (!enabled || event.action !== 'add' || !event.promise) return;
    void event.promise.then((result) => {
      if (result?.cart && !result.detail?.didError) play();
    }).catch(() => {});
  });
})();
